import { logger } from "@rshbintech.dboul/logger";
import { LoggingError, CryptoErrorPayload } from "../types";

/**
* Функция для разбития сложной строки из крипто параметров на объект

* @example splitName(
  `CN=МОРОЗОВ ИВАН АЛЕКСАНДРОВИЧ, O="ПАО ""ИНСТРУМЕНТАЛ""", C=RU, E=instrumental@gmail.com, T=1806380`
  ) -> {
  C: "RU"
  CN: "МОРОЗОВ ИВАН АЛЕКСАНДРОВИЧ"
  E: "instrumental@gmail.com"
  O: "\"ПАО \"\"ИНСТРУМЕНТАЛ\"\"\""
  T: "1806380"
  }
*/
export const splitName = (certificateProperty: string) => {
  const splitedName = {};
  const name = certificateProperty.split(", ");

  while (name.length > 0) {
    const symbol = name.shift();

    if (symbol) {
      const n = symbol.split("=");

      Object.assign(splitedName, { [n[0]]: n[1] });
    }
  }

  return splitedName;
};

/**
 *  Функция проверки наличия поля message в ошибке.
 */
const hasMessage = (error: unknown): error is CryptoErrorPayload =>
  (error as CryptoErrorPayload)?.message !== undefined &&
  typeof (error as CryptoErrorPayload)?.message === "string";

/**
 * Функция для пропуска ошибок плагина.
 */
export const shouldSendError = (error: unknown) => {
  if (!(error instanceof Error)) {
    return true;
  }

  // TODO Подумать стоит ли оставлять маппинг ошибок после исправления OB_PERS-838.
  // Ошибки появляются когда отключен плагин или не доступен.
  const SKIP_ERROR_PLUGIN_BROWSER = "CreateObjectAsync";
  const SKIP_ERROR_PLUGIN_FIREFOX = "pluginObject is undefined";

  return !(
    error.message.includes(SKIP_ERROR_PLUGIN_BROWSER) ||
    error.message.includes(SKIP_ERROR_PLUGIN_FIREFOX)
  );
};

/**
 * Общая функция пропуска ошибок из КриптоПро которые возвращаются в виде обьекта {message:"Test", requestid: "1", type:"Error"}.
 */
const shouldSendCryptoProError = (error: string) => {
  // TODO надо будем подумать стоит ли отсылать эту ошибку в logger, если пользователь отменит работу плагина. OB_PERS-843
  // Текст ошибки - Операция была отменена пользователем.
  const SKIP_ERROR = "0x000004C7";
  // TODO надо будем подумать стоит ли отсылать эту ошибку в logger. OB_PERS-843
  // Текст ошибки - Тип поставщика не определен.
  const SKIP_ERROR_TYPE = "0x80090017";
  const errorMessage = error.slice(error.indexOf("(") + 1, error.indexOf(")"));

  return !(errorMessage === SKIP_ERROR || errorMessage === SKIP_ERROR_TYPE);
};

/**
 * Функция отправки ошибки в logger.
 */
export const sendError = (error: LoggingError) => {
  if (error instanceof Error) {
    logger.sendError(error);
  } else if (hasMessage(error)) {
    if (shouldSendCryptoProError(error.message)) {
      logger.sendError(new Error(error.message));
    }
  } else {
    // logger.sendError(error)
  }
};
